import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Tooltip, Typography } from "antd";
import { useConsentStatusContext } from "../../context/ConsentStatusContext";
import { useConsentStatusConfig } from "../../hooks/useConsentStatusConfig";
import { StatusBadge, Dot, StatusText } from "./ConsentStatusBadge.styled";
import { WHITE } from "../../constant/colors";
import { fontWeights, sizes } from "../../constant/styles";

const { Text } = Typography;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: fit-content;
  max-width: 284px;
  position: relative;
`;

const Title = styled.div`
  font-weight: ${fontWeights.semibold};
  font-size: ${sizes.small};
  line-height: 1.5em;
`;

const ConsentStatus = () => {
  const { t } = useTranslation();
  const { consentStatus } = useConsentStatusContext();
  const [showTooltip, setShowTooltip] = useState(false);

  // Get status configuration using shared hook with tooltip data
  const config = useConsentStatusConfig(consentStatus.status, consentStatus);

  return (
    <Container>
      <Title>{t("consent.title")}</Title>
      <Tooltip
        title={<Text id="consent-status-tooltip-text">{config.tooltip}</Text>}
        placement="bottom"
        open={config.tooltip ? showTooltip : false}
        color={WHITE}
        overlayInnerStyle={{
          padding: "8px 12px",
          fontSize: sizes.small,
          fontWeight: fontWeights.semibold,
          textAlign: "center"
        }}
      >
        <StatusBadge
          compact
          hasTooltip={!!config.tooltip}
          onMouseEnter={() => config.tooltip && setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <Dot color={config.dotColor} />
          <StatusText>{config.text}</StatusText>
        </StatusBadge>
      </Tooltip>
    </Container>
  );
};

export default ConsentStatus;
